import { fromUrl } from '../utils/saveFile.js';
import { buildURL, fetchers } from '@pes-ui/utils';
import { exportType } from '../constants/constants';
import { log } from '../utils/console.js';

export class DocumentsAPI {
  REQUEST_DELAY = 3000;

  exportTokens = null;

  _console = null;

  constructor({ countryCode, languageCode }) {
    this.countryCode = countryCode;
    this.languageCode = languageCode;
    this.exportTokens = JSON.parse(localStorage.getItem('exportTokens'));
    this._console = log;
    this.init();
  }

  init() {
    if (this.exportTokens) {
      Object.keys(this.exportTokens).forEach((exportType) => {
        if (this.exportTokens[exportType]) {
          this.getDocumentUrlById(this.exportTokens[exportType], exportType);
        }
      });
    } else {
      this.exportTokens = {
        [exportType.excel]: '',
        [exportType.pdf]: '',
        [exportType.datasheet]: '',
      };
    }
  }

  getDocumentUrlByFormat(exportType) {
    return fetchers
      .getDocumentUrlByFormat({
        countryCode: this.countryCode,
        languageCode: this.languageCode,
        params: {
          format: exportType,
          t: new Date().getTime(), // Add timestamp query parameter to disable caching (actual for IE11)
        },
      })
      .then((response) => response.data)
      .then((documentData) => this.manageDocumentData(documentData, exportType))
      .catch((res) => this.logError(res));
  }

  getDocumentUrlById(exportId, exportType) {
    return fetchers
      .getDocumentUrlById({
        countryCode: this.countryCode,
        languageCode: this.languageCode,
        exportId,
      })
      .then((response) => response.data)
      .then((documentData) => this.manageDocumentData(documentData, exportType))
      .catch((res) => {
        this.saveExportId('', exportType);
        this.logError(res);
      });
  }

  getDocumentUrlByIdWithDelay(exportId, exportType, delay) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(this.getDocumentUrlById(exportId, exportType)), delay);
    });
  }

  manageDocumentData(documentData, exportType) {
    if (documentData.downloadUrl) {
      this.saveExportId('', exportType);
      return fromUrl(
        buildURL({
          host: window.location.origin,
          countryCode: this.countryCode,
          languageCode: this.languageCode,
          endpoint: documentData.downloadUrl,
        }),
      );
    }

    if (documentData.exportId) {
      this.saveExportId(documentData.exportId, exportType);
    }

    return this.getDocumentUrlByIdWithDelay(
      this.exportTokens[exportType],
      exportType,
      this.REQUEST_DELAY,
    );
  }

  saveExportId(exportId, exportType) {
    this.exportTokens[exportType] = exportId;
    localStorage.setItem('exportTokens', JSON.stringify(this.exportTokens));
  }

  logError(res) {
    this._console.error(`Status: ${res.status} Status text: ${res.statusText}`);
  }
}
